import {IRefCounter} from "./PA.Concurrency.IF.RefCounter";
import {BehaviorSubject} from "rxjs/Rx";

export class RefCounter
    implements IRefCounter {

    private _refCount: number
    private _onRefCounterChanged: BehaviorSubject<{refCounter:IRefCounter, count:number}>
    private _refObject: any

    constructor(obj: any) {
        this._refObject = obj
        this._refCount = 0
        this._onRefCounterChanged = new BehaviorSubject<{refCounter:IRefCounter, count:number}>(undefined)
    }

    get RefCount(): number {
        return this._refCount
    }

    acquireReference(): void {
        this._refCount += 1
        this._onRefCounterChanged.next({refCounter:this, count:this._refCount})
    }

    releaseReference(): void {
        this._refCount -= 1
        this._onRefCounterChanged.next({refCounter:this, count:this._refCount})
    }

    get OnRefCounterChanged(): BehaviorSubject<{refCounter:IRefCounter, count:number}> {
        return this._onRefCounterChanged
    }

    get RefObject(): any {
        return this._refObject
    }
}